import axios from 'axios';
import { tokenManager } from '../utils/tokenManager.js';

export const apiCall = async (url, options = {}) => {
  try {
    
    
    if (!url || url === 'undefined' || url === undefined) {
      console.error('Invalid API URL:', url);
      throw new Error('Invalid API URL. Check your environment variables.');
    }

    const method = options.method || 'GET';
    const data = options.data;
    const headers = options.headers || {};
    const authToken = options.authToken;
    const skipAutoRedirect = options.skipAutoRedirect || false;
    const config = {
      method,
      url,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      timeout: 30000 // 30 second timeout
    };

    // Add data for POST/PUT requests
    if (data && (method === 'POST' || method === 'PUT')) {
      config.data = data;
    }

    // Add authentication token
    if (authToken === null) {
      // Explicitly don't add auth token
    } else if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    } else {
      const token = tokenManager.getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }   

    const response = await axios(config);
    
   
    
    return response;
  } catch (error) {    
    const method = options.method || 'GET';
    const skipAutoRedirect = options.skipAutoRedirect || false;
    
    console.error('API Call Error:', {
      url,
      method: method,
      error: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      responseData: error.response?.data
    });

    if (error.response?.status === 401 && !skipAutoRedirect) {
      // Token expired or invalid - but only redirect if not explicitly skipped
      tokenManager.logout();
      window.location.href = '/login';
      return;
    }
    
    throw error;
  }
};

export default { apiCall };